import {Modal,Form,Input,Switch} from "antd"
import AcademicUnitService from "./../../../services/AcademicUnitService"
import { useEffect, useState } from "react";

export default function AcademicUnitFormModal(props) {
    const [form]=Form.useForm();
    const { visible, Option, ShowCreateModal,hideCreateModal, updatedTable,AcademicUnitTarget,CampusId } = props;
    const [isChecked,setIsChecked]=useState(true)
    
    const createAcademicUnit= ()=>{
        form.validateFields().then(
            val=>{
                const newAcademicUnit={
                    ...val,
                    campusId: CampusId,
                }
                form.resetFields();
                console.log("newAcademicUnit",newAcademicUnit);   
                AcademicUnitService.createAcademicUnit(newAcademicUnit).then((res)=>{
                    console.log("Create",res)
                });
                updatedTable(true);
                hideCreateModal(false);
            })
    }
    const updateAcademicUnit=()=>{
        console.log(AcademicUnitTarget)
        console.log(form.getFieldsValue())
        form.validateFields().then(
            val=>{
                form.resetFields();
                console.log("val",val);   
                AcademicUnitService.updateAcademicUnit(AcademicUnitTarget.id,val).then((res)=>{
                    console.log("update",res)
                });
                updatedTable(true);
                hideCreateModal(false); 
            })
    }
    useEffect(()=>{
        console.log(AcademicUnitTarget)
        form.setFieldsValue(Option? form.resetFields() : AcademicUnitTarget)
        setIsChecked(AcademicUnitTarget.status)
    },[AcademicUnitTarget,ShowCreateModal,Option])

    const handleOnOK=()=>{
        if(Option){
            createAcademicUnit()
        }else{
            updateAcademicUnit()
        }
    }
    return(
    <Modal 
    title="Unidad academica"
    open={visible}
    onOk={handleOnOK}
    onCancel={()=>{
        hideCreateModal(false)
        form.validateFields().then(
            val=>{
                form.resetFields();
            })
    }}
    >
        <Form 
            form={form}
            name='formCampus'
            key={"id"}
            labelWrap={true}
            layout="horizontal"
            >
                <Form.Item 
                name="name"
                label="Nombre"
                rules={[
                    {
                        required:true,
                        message:"Por Favor, ingrese el nombre de la unidad académica",
                    },
                    // {
                    //     min: 2, max:13, message: "Ingrese un nombre de tamaño de 2 a 13 letras"
                    // }
                ]
                }>
                    <Input placeholder='Ej: La Paz,Cochabamba,etc'></Input>
                </Form.Item>
                <Form.Item 
                name='location'
                label="Localización"
                rules={[
                    {
                        required:true,
                        message:"Por Favor, ingrese la ubicación de la unidad académica",
                    }
                ]
                }
                >
                    <Input placeholder='Codigo de la unidad académica'></Input>
                </Form.Item>
                <Form.Item 
                name='status'
                label="Estado"
                >
                    <Switch checked={isChecked} onChange={setIsChecked} checkedChildren="Activo" unCheckedChildren="Inactivo"/>  
                </Form.Item>
                <Form.Item 
                name='code'
                label="Codigo"
                rules={[
                    {
                        required:true,
                        message:"Por Favor, ingrese el codigo de la unidad académica",
                    }
                ]
                }
                >
                    <Input placeholder='Codigo de la unidad académica'></Input>
                </Form.Item>
        </Form>
    </Modal>
    );
}